import '/public/static/css/module/starrank/starrank.scss';
import {Autoplay, Navigation, Pagination} from 'swiper/modules';
import {SwiperSlide, Swiper} from 'swiper/react';
import StarRankThemeRankList from '@/components/starrank/pc/StarRankThemeRankList';
import {useEffect, useRef} from 'react';
import globalDomains from '@/utils/global-domains';
import StarRankSwiperItem from '@/components/starrank/pc/StarRankSwiperItem';
import {StarrankT} from '@/utils/i18n/starrank';

/**
 * 별별랭킹 PC 레이아웃
 */
const StarRankPcLayout = ({
  starRankBestData,
  starRankListData,
  starRankBestDataCnt,
  onClickLaterViewBtn,
  isLoading,
}) => {
  const updateSwiperBackground = () => {
    const imgFileUrl = document.querySelector(
      '.swiper-slide-active .thumbs-box a img',
    )?.src;

    if (imgFileUrl) {
      const bgBox = document.getElementById('bgBox');
      bgBox.style.backgroundImage = `url(${imgFileUrl})`;
    }
  };

  const swiperRef = useRef(null);

  /**
   * 스와이퍼 영역에 메뉴가 표시 중일 땐 자동 스크롤을 멈춘다.
   * @param {boolean} isVisible
   * @returns
   */
  const handleOnMenuVisibilityChanged = (isVisible) => {
    if (isVisible) {
      swiperRef?.current?.swiper.autoplay.stop();
    } else {
      swiperRef?.current?.swiper.autoplay.start();
    }
  };

  useEffect(() => {
    let gnbElement = null,
      lnbElement = null;

    // Soop Navigation(GNB/LNB)이 로드되는 것을 기다리기
    const gnbObserver = new MutationObserver(() => {
      gnbElement = document.querySelector(
        '#soop_wrap.soop-wrap-starrank #soop-gnb #serviceHeader',
      );
      if (gnbElement) {
        gnbObserver.disconnect();
      }
    });

    const lnbObserver = new MutationObserver(() => {
      lnbElement = document.querySelector(
        '#soop_wrap.soop-wrap-starrank #serviceLnb',
      );
      if (lnbElement) {
        lnbObserver.disconnect();
      }
    });

    gnbObserver.observe(document.body, {childList: true, subtree: true});
    lnbObserver.observe(document.body, {childList: true, subtree: true});

    /**
     * 별별랭킹 페이지가 좌우 스크롤할 때 GNB/LNB의 위치를 보정한다.
     */
    const handleHorizontalScroll = (event) => {
      const scrollX = window.scrollX || document.documentElement.scrollLeft;

      if (gnbElement) {
        gnbElement.style.transform = `translate(-${scrollX}px)`;
      }

      if (lnbElement) {
        lnbElement.style.transform = `translate(-${scrollX}px)`;
      }
    };

    window.addEventListener('scroll', handleHorizontalScroll);

    return () => {
      gnbObserver.disconnect();
      lnbObserver.disconnect();

      window.removeEventListener('scroll', handleHorizontalScroll);
    };
  }, []);

  return (
    <>
      <div id='container' className='starrank-pc-container'>
        {starRankBestDataCnt > 0 ? (
          <div id='list-section'>
            <div className='rank-stage'>
              <div className='title-wrap'>
                <div className='inBox'>
                  <h2>{StarrankT('별별랭킹')}</h2>
                  <a
                    href={`${globalDomains.AFEVENT2_AFREECATV}/app/rank/index.php`}
                    target='_blank'>
                    {StarrankT('스트리머 랭킹')}
                  </a>
                </div>
              </div>
              <div className='bg-box' id='bgBox'></div>
              {/* TODO: <SoopUiSwiper/> 기반으로 변경, (현상황에 바로 적용 시 스타일 깨짐 문제가 있음) */}
              <Swiper
                ref={swiperRef}
                modules={[Navigation, Pagination, Autoplay]}
                className='list-carousel'
                wrapperTag='ul'
                centeredSlides={true}
                slidesPerView='auto'
                loop={true}
                loopAdditionalSlides={1}
                data-broadcast='live'
                autoplay={{
                  delay: 5000,
                  disableOnInteraction: false,
                }}
                navigation={{
                  prevEl: '.list-carousel .btn-prev',
                  nextEl: '.list-carousel .btn-next',
                }}
                pagination={{
                  el: '.list-carousel .pagination',
                  clickable: true,
                }}
                onSlideChangeTransitionEnd={updateSwiperBackground}
                onAfterInit={updateSwiperBackground}>
                {starRankBestData.map((broadItem) => {
                  return (
                    <SwiperSlide
                      tag='li'
                      data-type='cBox'
                      key={broadItem.broadNo}>
                      <StarRankSwiperItem
                        broadItem={broadItem}
                        onClickLaterViewBtn={onClickLaterViewBtn}
                        onMenuVisibilityChanged={handleOnMenuVisibilityChanged}
                      />
                    </SwiperSlide>
                  );
                })}
                <div className='pagination'></div>
                <button
                  className='btn-prev'
                  tabIndex={0}
                  role='button'
                  aria-label='Previous slide'>
                  {StarrankT('이전')}
                </button>
                <button
                  className='btn-next'
                  tabIndex={0}
                  role='button'
                  aria-label='Next slide'>
                  {StarrankT('다음')}
                </button>
              </Swiper>
            </div>
            <div className='cBox-list_wrap'>
              {starRankListData.map((broadItem, index) => {
                return (
                  <StarRankThemeRankList
                    broadItemList={broadItem}
                    key={`starrank-${index}`}
                  />
                );
              })}
            </div>
          </div>
        ) : (
          /* TODO: 데이터 없음 or 로딩 중 화면에 대한 스타일링 */
          <div
            style={{textAlign: 'center', opacity: !isLoading ? 100 : 0}}
            dangerouslySetInnerHTML={{
              __html: StarrankT(
                `<h2>별별랭킹 데이터가 없습니다.</h2><br /><p>다음에 다시 이용해주세요.</p>`,
              ),
            }}></div>
        )}
      </div>
    </>
  );
};

export default StarRankPcLayout;
